var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _mask, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 742,
    height: 860,
    viewBox: "0 0 742 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 136.5,
    cy: 146.5,
    r: 30.5,
    fill: "url(#paint0_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 768,
    cy: 705,
    r: 155,
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 378,
    r: 182,
    fill: "url(#paint2_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.472 238.114C522.26 232.492 509.369 216.72 504.98 213.017C505.049 212.743 504.02 211.097 503.54 210.48C502.923 209.657 502.512 208.766 502.237 207.874C500.523 205.474 500.386 201.566 499.837 198C497.094 200.057 494.9 204.103 494.146 208.011C494.9 208.08 494.009 208.149 494.077 208.149C494.077 208.08 494.077 208.011 494.146 208.011C493.186 207.943 492.02 207.806 491.266 207.737C491.266 207.669 491.266 207.669 491.266 207.6C474.74 201.771 452.66 203.417 437.643 211.851C437.78 211.646 419.197 224.331 409.666 230.503C397.528 238.32 369.208 248.469 368.797 248.606C360.157 252.446 349.803 252.034 340.82 254.983C333.483 257.383 326.968 261.154 320.797 264.446C322.443 265.2 324.157 265.886 325.871 266.503C342.191 256.354 361.186 252.103 382.854 260.949C383.197 261.086 383.608 261.223 383.951 261.429C383.883 261.36 383.746 261.36 383.677 261.292C409.597 245.794 432.226 242.366 456.226 249.223C456.226 249.223 460.203 250.389 460.34 249.977C460.683 248.057 462.946 240.172 463.632 238.8C466.854 231.943 477.346 229.817 485.232 232.56C485.3 232.423 483.243 228.926 485.506 224.606C481.597 236.194 497.712 242.709 504.774 241.063C511.014 243.943 512.592 248.469 520.34 249.977C528.912 249.292 530.626 241.749 527.472 238.114Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.437 271.509L352.066 262.526C349.597 262.732 347.197 263.143 344.866 263.692C345.14 265.406 345.894 269.52 346.169 271.372C348.637 271.509 351.037 271.578 353.437 271.509Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.3 269.794C364.957 267.806 364.34 264.514 364.134 262.937C361.323 262.526 358.58 262.32 355.906 262.32L357.277 271.234C359.951 270.96 362.626 270.48 365.3 269.794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M460.683 252.994C443.814 269.52 419.197 283.44 384.226 269.725C384.5 269.863 384.637 269.863 384.637 269.863C370.443 279.12 349.666 280.971 326.831 271.234C321.826 274.251 317.026 277.543 312.363 281.04C297.826 307.097 268.683 323.211 248.866 356.811C242.557 366.891 238.168 381.977 239.06 384.103C259.22 338.708 298.443 310.457 354.946 299.485C366.466 296.811 366.329 290.297 369.689 290.365C386.352 290.777 398.832 288.24 409.46 283.508C414.603 281.245 418.649 278.16 424.34 276.583C424.409 276.445 424.477 276.308 424.546 276.103C428.249 277.885 432.637 278.914 437.369 278.914C438.877 278.914 440.386 278.777 441.826 278.571L440.866 279.943L401.78 319.645L480.706 274.32C480.5 274.32 460.546 253.2 460.683 252.994Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.368 264.651C338.968 265.406 336.568 266.297 334.237 267.394C334.305 268.217 334.374 269.314 334.374 269.383C336.98 270.069 339.654 270.617 342.26 270.96C341.985 269.04 341.574 266.229 341.368 264.651Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M368.111 263.692C368.317 265.2 368.66 267.257 368.866 268.766C371.128 268.012 373.391 267.12 375.586 266.023C372.98 264.995 370.511 264.24 368.111 263.692Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.946 252.172C424.34 252.514 421.666 252.994 419.06 253.68L421.254 268.08C424.066 267.737 426.74 267.12 429.277 266.366C428.797 263.349 427.22 254.092 426.946 252.172Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440.934 251.554C437.506 251.417 434.146 251.486 430.717 251.76C431.06 253.748 432.226 261.703 432.706 265.131C435.792 263.897 438.74 262.388 441.552 260.606L440.934 251.554Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444.637 251.829L444.911 258.343C447.311 256.629 449.643 254.777 451.974 252.857C449.574 252.377 447.106 252.035 444.637 251.829Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.112 264.926C393.346 265.337 394.58 265.749 395.814 266.092C395.814 266.023 395.746 264.583 395.746 262.8C394.58 263.486 393.346 264.172 392.112 264.926Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M417.414 268.423L415.289 254.709C413.026 255.395 410.694 256.149 408.431 257.04C408.98 260.126 410.077 266.503 410.351 268.355C412.889 268.492 415.22 268.492 417.414 268.423Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.511 267.806C406.237 266.024 405.483 261.361 405.071 258.344C402.74 259.372 400.409 260.469 398.009 261.704C398.146 262.938 398.557 266.161 398.557 266.161C398.557 266.161 398.351 266.092 398.077 266.092C401.026 266.915 403.837 267.464 406.511 267.806Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M320.523 270.686C319.083 269.932 317.78 269.109 316.546 268.217C316.546 268.217 316.546 268.217 316.546 268.286C298.786 255.806 281.094 271.989 260.385 265.063C254.694 263.143 248.454 259.029 241.597 257.931C232.065 256.423 218.9 260.674 217.323 269.04C230.283 256.834 249.345 274.114 266.968 279.943C273.551 282.069 281.711 283.234 287.197 282.617C294.808 281.863 300.637 276.857 308.043 275.006C308.866 274.8 317.026 271.714 320.523 270.686Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 344,
    width: 315,
    height: 195
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.828 491.41H305.33C310.316 491.41 314.822 488.635 317.171 484.283C319.089 480.695 321.869 477.155 325.321 477.155C328.629 477.155 331.17 480.504 332.848 483.948C335.101 488.54 339.751 491.41 344.881 491.41H354.325C356.003 491.41 357.585 492.223 358.592 493.562L364.729 501.886L374.94 344.703L382.658 538L388.411 496.576C388.843 493.61 391.384 491.362 394.404 491.362H415.019C419.285 491.362 423.312 489.353 425.853 485.861C430.695 479.212 439.133 468.928 444.598 468.928C449.92 468.928 457.35 478.734 461.761 485.383C464.254 489.114 468.425 491.314 472.931 491.314H473.65C476.623 491.314 479.499 490.31 481.848 488.54C483.478 487.296 485.348 486.1 486.642 486.1C489.327 486.1 491.628 491.362 498.484 491.362C505.387 491.362 548.582 491.362 548.582 491.362",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 378,
    r: 182,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 764,
    height: 764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.5,
    y1: 216,
    x2: 106,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 884.885,
    y1: 1058.2,
    x2: 613,
    y2: 354.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 432,
    y1: 552.5,
    x2: 295,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder1);
export default __webpack_public_path__ + "static/media/placeholder1.045a1471.svg";
export { ForwardRef as ReactComponent };